<template>
  <div class="page-container">
    <ConfirmationDialogBox
      :title="'Remove AI Pool member? This action can not be undone.'"
      :isVisible="isDialogVisible"
      @confirmed="handleConfirmed"
      @cancelled="handleCancelled">
    </ConfirmationDialogBox>
    
    <ModalBox 
      :visible="showModal" 
      :infoTitle="infoTitle"  
      :infoMessage="infoMessage" 
      @close="showModal = false">
    </ModalBox>
    <!-- <div class="tabs">
      <button 
        v-for="tab in tabs" 
        :key="tab.name" 
        :class="{ active: activeTab === tab.name, inactive: activeTab !== tab.name }" 
        @click="activeTab = tab.name">
        {{ tab.label }}
      </button>
    </div> -->
    <div class="tab-content">  
      <!-- <div v-if="activeTab === 'tab2'">    
       <ApiDoc></ApiDoc>
      </div> -->
      <div v-if="activeTab === 'tab1'">    
        <div v-if="activeView === 'PoolTableView'">
         <div class="tools-container" >
            <router-link to="/retailer" class="custom-button" v-if="access_level == 10">
              Retailer NMI Feed
            </router-link>

         <a :href="rdPortalUrl" class="custom-button" v-if="access_level == 10">
          R&D Portal
        </a>
                
       
            <button class="custom-button" v-if="access_level == 10" @click="activeView = 'PoolNewMemberView'">
              Add New
            </button>
            <router-link to="/advanced-capabilities" class="custom-button" v-if="access_level == 10">
              Advanced Capabilities
            </router-link>
          </div>
   
          <!-- Pool Statistics Info -->
          <div class="pool-stats-container" v-if="access_level == 10">
            <div class="stats-card">
              <div class="stat-item">
                <span class="stat-label">Total Members</span>
                <span class="stat-value">{{ filteredPoolDataList.length }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">LocalVolts</span>
                <span class="stat-value">{{ getRetailerCount(2) }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">Amber</span>
                <span class="stat-value">{{ getRetailerCount(1) }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">Offline</span>
                <span class="stat-value" :class="{ warning: getOfflineCount() > 0 }">{{ getOfflineCount() }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">AI Control Inactive</span>
                <span class="stat-value" :class="{ warning: getRealtimeInactiveCount() > 0 }">{{ getRealtimeInactiveCount() }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">AI Control Error</span>
                <span class="stat-value" :class="{ warning: getRealtimeErrorCount() > 0 }">{{ getRealtimeErrorCount() }}</span>
              </div>
            </div>
          </div>

          <div class="table-container">
            <!-- Search Box -->
            <div class="search-container">
              <input 
                type="text" 
                v-model="searchTerm" 
                placeholder="Search by alias, plant ID, retailer, or any field..." 
                class="search-input"
                @input="filterTableData"
              />
              <button 
                v-if="searchTerm" 
                @click="clearSearch" 
                class="clear-search-btn"
                title="Clear search"
              >
                ✕
              </button>
            </div>
            
            <table class="full-width-table">
              <thead>
                <tr>
                  <th v-for="header in tableHeaders" :key="header">{{ header }}</th>
                  <th v-if="access_level == 10">Actions</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="row in filteredPoolDataList" :key="row.plant_id">
                  <tr :class="{ 'abnormal-device-row': row.abnormal_device_status === 1 }">
                    <td @click="navigateToDetails(row)" class="clickable-cell">
                      <div class="alias-cell">
                        {{ row.alias }}
                        <span v-if="isRecentlyAdded(row.date_added)" class="new-badge">
                          {{ getNewBadgeText(row.date_added) }}
                        </span>
                      </div>
                    </td>
                    <td>{{ row.plant_id }}</td>
                    <td>
                      <template v-if="row.ai_control_status == 0">
                        <font-awesome-icon :icon="['fas', 'link-slash']" class="icon-disabled" />
                      <p>Disabled</p>
                      </template>
                      <template v-else-if="row.ai_control_status == 1">
                        <font-awesome-icon :icon="['fas', 'circle-check']" class="icon-enabled" />
                      <p>Enabled [AUTO]</p>
                      </template>
                      <template v-else-if="row.ai_control_status == 1001">
                        <font-awesome-icon :icon="['fas', 'circle-check']" class="icon-enabled" />
                      <p>Off [Debug]</p>
                      </template>
                      <template v-else-if="row.ai_control_status == 2">
                        <font-awesome-icon :icon="['fas', 'circle-check']" class="icon-enabled" />
                      <p>Special Case [TIMED]</p>
                      </template>
                      <template v-else-if="row.ai_control_status == 3">
                        <font-awesome-icon :icon="['fas', 'circle-check']" class="icon-enabled" />
                      <p>v1.0.0</p>
                      </template>
                      <template v-else-if="row.ai_control_status == 4">
                        <font-awesome-icon :icon="['fas', 'circle-check']" class="icon-enabled" />
                      <p>v2.0.0</p>
                      </template>
                      <template v-else-if="row.ai_control_status == 5">
                        <font-awesome-icon :icon="['fas', 'circle-check']" class="icon-enabled" />
                      <p>v1.1.0</p>
                      </template>
                      <template v-else-if="row.ai_control_status == 6">
                        <font-awesome-icon :icon="['fas', 'circle-check']" class="icon-enabled" />
                      <p>v1.1.1</p>
                      </template>
                      <template v-else-if="row.ai_control_status == 7">
                        <font-awesome-icon :icon="['fas', 'circle-check']" class="icon-enabled" />
                      <p>v1.1.2</p>
                      </template>
                      <template v-else-if="row.ai_control_status == 8">
                        <font-awesome-icon :icon="['fas', 'circle-check']" class="icon-enabled" />
                      <p>v1.1.3</p>
                      </template>
                      <template v-else-if="row.ai_control_status == 9">
                        <font-awesome-icon :icon="['fas', 'circle-check']" class="icon-enabled" />
                      <p>v1.2.0</p>
                      </template>
                      <template v-else-if="row.ai_control_status == 10">
                        <font-awesome-icon :icon="['fas', 'circle-check']" class="icon-enabled" />
                      <p>v1.2.0-jcs</p>
                      </template>
                      <template v-else-if="row.ai_control_status == 11">
                        <font-awesome-icon :icon="['fas', 'circle-check']" class="icon-enabled" />
                      <p>v1.2.1</p>
                      </template>
                      <template v-else-if="row.ai_control_status == 12">
                        <font-awesome-icon :icon="['fas', 'circle-check']" class="icon-enabled" />
                      <p>v1.2.2</p>
                      </template>
                      <template v-else-if="row.ai_control_status == 13">
                        <font-awesome-icon :icon="['fas', 'circle-check']" class="icon-enabled" />
                      <p>v1.3.0</p>
                      </template>
                    </td>
                    <td>
                      <template v-if="row.realtime_operation_status == 1">
                        <div class="status-circle status-enabled blink"></div>
                        <p>Active</p>
                      </template>
                      <template v-else-if="row.realtime_operation_status == 2">
                        <div class="status-circle status-error"></div>
                        <p>Error</p>
                      </template>
                      <template v-else>
                        <div class="status-circle status-disabled"></div>
                        <p>Inactive</p>                       
                      </template>
                    </td>
                    <td>
                      <template v-if="statusLoading[row.plant_id] === true">
                        <div class="status-loading-container">
                          <div class="status-loading-spinner"></div>
                          <p>Checking...</p>
                        </div>
                      </template>
                      <template v-else-if="row.abnormal_device_status === 1">
                        <div class="status-circle status-warning"></div>
                          <p>
                            {{ row.abnormal_device_count }} 
                            {{ row.abnormal_device_count === 1 ? 'Device' : 'Devices' }} 
                            Offline
                          </p>
                      </template>
                      <template v-else>
                        <div class="status-circle status-enabled"></div>
                        <p>All Online</p>
                      </template>
                    </td>
                    <td>{{ formatDate(row.date_added) }}</td>
                    <td>{{ getRetailerName(row.retailer_id) }}</td>
                    <td v-if="access_level == 10" class="action-buttons-column">
                      <button @click="toggleDetails(row)" class="custom-button arrow-button neutral-button">
                        {{ showDetails[row.plant_id] ? '▲' : '▼' }}
                      </button>
                      <button 
                        class="custom-button arrow-button sensitive-button" 
                        @click="showConfirmationDialog(row)">
                        X
                      </button>
                    </td>
                  </tr>
                  <tr v-if="showDetails[row.plant_id]">
                    <td :colspan="access_level == 10 ? 8 : 7">
                      <div class="details-row">
                        <h5><strong>Set / Modify Details</strong></h5>
                        <br>
                        <form :key="row.plant_id" autocomplete="off">
                        <!-- <p>Plant ID: {{ row.plant_id }}</p> -->
                        <!-- <p>: {{ row.alias }}</p> -->
                        <button type="button" @click="toggleAdvancedFields()" class="custom-button" v-if="access_level == 10"> 🔒 Show Advanced Fields</button>
                        <br>
                        <br>
                        <label for="aliasValue">Alias</label>
                        <br>
                        <input id="aliasValue" type="text" v-model="form.alias" autocomplete="off" required />
                        <br>
                        <br>
                        <br>
          <label for="aiControlStatus">AI Control</label>
          <br>
          <select v-model="form.ai_control_status" required>
            <option value=0>Disabled</option>
            <option value=1>Enabled [AUTO]</option>
            <option value=1001>Off [Debug]</option>
            <option value=2>Special Case [TIMED]</option>
            <option value=3>v1.0.0</option>
            <option value=4>v2.0.0</option>
            <option value=5>v1.1.0</option>
            <option value=6>v1.1.1</option>
            <option value=7>v1.1.2</option>
            <option value=8>v1.1.3</option>
            <option value=9>v1.2.0</option>
            <option value=10>v1.2.0-jcs</option>
            <option value=11>v1.2.1</option>
            <option value=12>v1.2.2</option>
            <option value=13>v1.3.0</option>
          </select>
          <br>
          <br>
          <br>

          
<br>
<br>
<div v-if="showAdvancedFields" class="sensitive-fields-container">
  <div class="sensitive-warning">
    ⚠️ <strong>WARNING:</strong> These are sensitive values. Be careful when editing!
  </div>
  <label for="retailerApiKey">Retailer API Key</label>
  <br>
  <input type="text" v-model="form.retailer_api_key" />
  <br>
  <br>
  <label for="retailerId">Retailer</label>
  <br>
  <select v-model="form.retailer_id">
    <option value="1">Amber</option>
    <option value="2">LocalVolts</option>
  </select>
  <br>
  <br>
  <label for="retailerSiteId">Retailer Site ID</label>
  <br>
  <input type="text" v-model="form.retailer_site_id" />
  <br>
  <br>
</div>

          <button type="button" @click="saveChanges(row)" class="custom-button">Save Changes</button>
          <br>
          <br>
          <br>

        </form>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="activeView === 'PoolNewMemberView'" class="flex-container">
          <div class="flex-container">
            <button class="custom-button" @click="activeView = 'PoolTableView'">
              Back To Pool View
            </button>
          </div>
   
          <h5>Add new plant to the pool</h5>
            <div class="options">
              <button 
                class="button-option" 
                :class="{ active: selectedMethod === 'byId' }" 
                @click="selectMethod('byId')">
                Add by ID
              </button>
              <button 
                class="button-option" 
                :class="{ active: selectedMethod === 'byAutocomplete' }" 
                @click="selectMethod('byAutocomplete')">
                Search by name
              </button>
            </div>

            <div v-if="selectedMethod === 'byId'">
              <h6>Enter Renox Plant ID</h6>
              <input 
                class="custom-input" 
                type="text" 
                v-model="memberId" 
                placeholder="Enter Plant ID" />                
              <button 
                class="custom-button"
                :class="{ active: (memberId != 0 && memberId != '' && Number(memberId)) }"
                @click="getPlantById">
                Continue
              </button>
            </div>

            <div v-if="selectedMethod === 'byAutocomplete'">
              <h6>Search for Renox account and plant names</h6>
              <input 
                class="custom-input" 
                type="text" 
                v-model="searchTermAutocomplete" 
                placeholder="Type to search..." 
                @input="getPlantByAutocomplete(searchTermAutocomplete)" />
            </div>

            <h6>Found Plants ({{ listPlantByIdDataResponse.length }})</h6>
            <div class="result-box" v-if="listPlantByIdDataResponse.length > 0">
              <div v-for="(item, index) in listPlantByIdDataResponse" :key="index">
                <ul>
                  <a href="#" @click.prevent="selectedResultIndex = index">
                    <li>
                      <div 
                        class="result-item styled-border" 
                        :class="{ selectedResult: (selectedResultIndex === index) }">
                        <p>Plant ID: {{ item.plant_id }}</p>
                        <p>Plant Name: {{ item.plant_name }}</p>
                        <p>Account Name: {{ item.account_name }}</p>
                        <p>Date Created: {{ item.date_created }}</p>
                      </div>
                    </li>
                  </a>
                </ul>
              </div> 
              <div class="flex-container">
                <button 
                  class="custom-button"
                  :class="{ active: selectedResultIndex != -1 }"      
                  @click="addPlantToPool">
                  Add To Pool
                </button>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo, getDevModeState } from '@/services/cookieService';
import { eventBus } from '@/services/eventBus';
import { apiRequest } from '@/services/apiService';
import ModalBox from '@/components/cards/ModalBox.vue';
import ConfirmationDialogBox from '@/components/cards/ConfirmationDialogBox.vue';
import ApiDoc from '../cards/ApiDoc.vue';

export default {
name: 'ConfigurationPage',
components: {
  ModalBox,
  ConfirmationDialogBox,
  ApiDoc,
},
computed: {
    rdPortalUrl() {
      return process.env.NODE_ENV === 'production' 
        ? 'https://ai.redxvpp.com/rd/' 
        : 'https://dev-ai.redxvpp.com/rd/';
    }
  },
data() {
  return {
    lastRun: null,
    intervalId: null,
    form: {
      alias: '',
      ai_control_status: 0,
      retailer_api_key: '',
      retailer_id: 1,
      retailer_site_id: '',
    },
    isDialogVisible: false,
    subDataUrl: '/api/v1.1/data',
    tableHeaders: ['Alias', 'Renox Plant ID', 'AI Control', 'Realtime Operation Status', 'Plant Devices Health', 'Date Added', 'Retailer'],
    showDetails: {},
    poolDataList: [],
    filteredPoolDataList: [], // Add filtered data list
    access_level: 0,
    activeTab: 'tab1',
    tabs: [
      { name: 'tab1', label: 'AI Pool' },
      { name: 'tab2', label: 'System Notifications' },
    ],
    selectedMethod: 'byAutocomplete',
    memberId: '',
    searchTerm: '', // This will be used for table search
    searchTermAutocomplete: '', // Rename the existing search term for autocomplete
    activeView: 'PoolTableView',
    listPlantByIdDataResponse: [],
    selectedResultIndex: -1,
    selectedPlantId: null,
    showModal: false,
    infoTitle: '',
    infoMessage: '',
    scrollPosition: 0, // Store scroll position
    scrollPositionKey: 'homepage-scroll-position', // Key for localStorage
    isOnHomePage: false, // Track if we're actually on HomePage
    showAdvancedFields: false, // New state variable for advanced fields
    statusLoading: {}, // Track loading state for each plant's status (key: plant_id, value: boolean)
  };
},
methods: {
    handleEnvironmentChange(isDevMode) {
      console.log("isDevMode:", isDevMode);
      this.subDataUrl = isDevMode ? "/dev-api/api/v1.1/data" : "/api/v1.1/data";
      // Trigger a refresh of the data when environment changes
      this.getAllPoolData();
    },
    readFromCookies() {
      let cookieData = getUserInfo();
      if (cookieData) {
        this.access_level = cookieData.accessLevel;
      }

      // Initialize subDataUrl based on dev mode state from cookies
      const devModeState = getDevModeState();
      if (devModeState.isDevMode !== undefined) {
        this.subDataUrl = devModeState.isDevMode ? "/dev-api/api/v1.1/data" : "/api/v1.1/data";
      }
    },
  // Start the interval to run every defined minutes
  startInterval() {
      // Check if an interval is already running
      if (!this.intervalId) {
        this.intervalId = setInterval(async () => {
          await this.checkRealtimeRunningStatus();
        }, 3 * 60 * 1000);
        // console.log('Interval started');
      }
    },

    // Stop the interval
    stopInterval() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
        // console.log('Interval stopped');
      }
    },

  // Setup scroll event listener
  setupScrollListener() {
    this.handleScroll = this.debounce(() => {
      // Only save scroll position if we are on the HomePage
      if (this.isOnHomePage) {
        this.saveScrollPosition();
      }
    }, 100); // Debounce scroll events to avoid excessive localStorage writes
    
    window.addEventListener('scroll', this.handleScroll);
  },

  // Remove scroll event listener
  removeScrollListener() {
    if (this.handleScroll) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  },

  // Debounce function to limit function calls
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  },

  // Save scroll position to localStorage
  saveScrollPosition() {
    // Only save if we're actually on the HomePage
    if (!this.isOnHomePage) {
      return;
    }
    
    this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    localStorage.setItem(this.scrollPositionKey, this.scrollPosition.toString());
  },

  // Restore scroll position from localStorage
  restoreScrollPosition() {
    const savedPosition = localStorage.getItem(this.scrollPositionKey);
    if (savedPosition) {
      this.scrollPosition = parseInt(savedPosition, 10);
      // Use nextTick to ensure DOM is updated before scrolling
      this.$nextTick(() => {
        window.scrollTo({
          top: this.scrollPosition,
          behavior: 'instant' // Use instant to avoid animation
        });
      });
    }
  },

  // Clear saved scroll position
  clearScrollPosition() {
    localStorage.removeItem(this.scrollPositionKey);
    this.scrollPosition = 0;
  },

  // Handle Vue Router navigation
  handleRouteEnter() {
    // When entering this route, restore scroll position
    this.isOnHomePage = true; // Mark that we're back on HomePage
    this.$nextTick(() => {
      this.restoreScrollPosition();
    });
  },

  // Handle page visibility change (when user returns from another page)
  handleVisibilityChange() {
    if (!document.hidden) {
      // Page is now visible, check if we're on HomePage
      if (this.$route.name === 'HomePage') {
        this.isOnHomePage = true;
        this.$nextTick(() => {
          this.restoreScrollPosition();
        });
      }
    }
  },

  // Setup page visibility listener
  setupVisibilityListener() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },

  // Remove page visibility listener
  removeVisibilityListener() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },

  // Handle browser navigation (back/forward buttons)
  handlePopState() {
    // When user navigates back to this page, check if we're on HomePage
    if (this.$route.name === 'HomePage') {
      this.isOnHomePage = true;
      this.$nextTick(() => {
        this.restoreScrollPosition();
      });
    }
  },

  // Setup popstate listener for browser navigation
  setupPopStateListener() {
    window.addEventListener('popstate', this.handlePopState);
  },

  // Remove popstate listener
  removePopStateListener() {
    window.removeEventListener('popstate', this.handlePopState);
  },

  navigateToDetails(row) {
        // Save current scroll position before navigating
        this.isOnHomePage = false; // Mark that we're leaving HomePage
        this.saveScrollPosition();
        
        const queryParams = {
          plant_id: row['plant_id'],
          alias: row['alias'],
          retailer_id: row['retailer_id'],
          date_added: row['date_added'] ?? '',
          retailer_name: this.getRetailerName(row['retailer_id']),
        };
        eventBus.emit('nav-click', 1);
        this.$router.push({ name: 'DetailPage', query: queryParams });
    },
  async getAllPoolData() {
    try {
      const url = `${this.subDataUrl}/ai_pool_users/get`;
      const response = await apiRequest('post', url, {});
      
      if (response.errorCode === 0 && response.data != null) {
        this.poolDataList = response.data;
   
        // Update filtered list and apply current search if any
        if (this.searchTerm.trim()) {
          this.filterTableData();
        } else {
          this.filteredPoolDataList = [...this.poolDataList];
        }
        this.checkRealtimeRunningStatus();
        // Clear expand state (keyed by plant_id)
        this.showDetails = {};

        // Check plant health status for abnormal devices
        await this.checkAllPlantsHealthStatus();

        // // Sort the poolDataList based on the ai_control_status
        // this.poolDataList.sort((a, b) => b.ai_control_status - a.ai_control_status);
        // console.log('AI pool data response data:', this.poolDataList);
        // this.poolDataList.push({"ID": 99, "plant_id": 999, "added_by": 1, "ai_control_status": 0, "alias": "Test Fictional Plant", "date_added": "2024-11-18T09:54:23.219+10:00", "date_modified": "2024-11-18T09:54:23.219+10:00", "max_capacity_limit": 0, "modified_by": 0, "realtime_operation_status": 0, "retailer_api_key": "", "retailer_id": 0, "retailer_partner_id": 0});
      }
    } catch (error) {
      // console.error('Error fetching ai pool data list:', error);
      this.showModal = true;
      this.infoTitle = "Error";
      this.infoMessage = "Failed to fetch pool data. Please try again later.";
    }
  },

  async getDeviceStatus(plantId, accountName) {
    try {
      const bodyData = {
        plantId: plantId,
        accountName: accountName,
      };
      const url = `${this.subDataUrl}/proxy/rx/device/get_device_list`;
      const response = await apiRequest('post', url, bodyData);

      return response;
    } catch (error) {
      console.log('Error fetching device online-offline status:', error);
    }
  },
  async checkAllPlantsHealthStatus() {
    if(this.access_level != 10) {
      // console.log('Access level is not 10, skipping plant health status check');
      return;
    }
    try {
      // Set loading state for all plants
      for (let index = 0; index < this.poolDataList.length; index++) {
        const plantId = this.poolDataList[index].plant_id;
        this.statusLoading[plantId] = true;
      }

      for (let index = 0; index < this.poolDataList.length; index++) {
        const value = this.poolDataList[index]; // Access the current object
        const plantId = this.poolDataList[index].plant_id;

        // Initialize abnormal device properties if they don't exist
        if (this.poolDataList[index].abnormal_device_status === undefined) {
          this.poolDataList[index].abnormal_device_status = 0;
        }
        if (this.poolDataList[index].abnormal_device_count === undefined) {
          this.poolDataList[index].abnormal_device_count = 0;
        }

        const plantData = await this.fetchPlantInfo(this.poolDataList[index].plant_id);


        if (plantData.length > 0) {
          let offlineDeviceCount = 0;
          const plant_device_data = await this.getDeviceStatus(this.poolDataList[index].plant_id, plantData.account_name);
          // console.log('Obtained plant_device_data: ', plant_device_data);
          if(plant_device_data.errorCode === 0 && plant_device_data.data.length > 0) {
            for (let deviceIndex = 0; deviceIndex < plant_device_data.data.length; deviceIndex++) {
              const device = plant_device_data.data[deviceIndex];
              const deviceStatus = device.showStatus; // Access the current object
              const deviceType = device.deviceType;
              
              // Only count devices where deviceType starts with "rx" (case insensitive)
              if (deviceType && deviceType.toLowerCase().startsWith('rx')) {
                if (deviceStatus === null || deviceStatus === "Offline") {
                  offlineDeviceCount++;
                }
              }
            }
                
          
          // Update the abnormal device status and count
          if (offlineDeviceCount > 0) {
            this.poolDataList[index].abnormal_device_status = 1;
            this.poolDataList[index].abnormal_device_count = offlineDeviceCount;
          } else {
            this.poolDataList[index].abnormal_device_status = 0;
            this.poolDataList[index].abnormal_device_count = 0;
          }
          // console.log('this.poolDataList[index]: ', this.poolDataList[index]);
          }
        }
        
        // Clear loading state for this plant
        this.statusLoading[plantId] = false;
      }
    } catch (error) {
      console.log('Error checking plant devices health status:', error);
      // Clear loading state for all plants on error
      for (let index = 0; index < this.poolDataList.length; index++) {
        const plantId = this.poolDataList[index].plant_id;
        this.statusLoading[plantId] = false;
      }
    }
  },
  async checkRealtimeRunningStatus() {
    if(this.poolDataList.length == 0) {
      return;
    }
    try {
      const target_server_slug = this.subDataUrl.includes('dev-api') ? 'dev/' : 'prod/';
      const url = `${this.subDataUrl}/proxy/ai_control/${target_server_slug}all_plants_status/get`;

      // Make single API call to fetch all plant statuses
      const response = await apiRequest('post', url, {});

      // Check if the response is valid and has data
      if (response && response.status === 'success' && response.data && Array.isArray(response.data)) {
        // Create a map of plant_id to status for quick lookup
        const statusMap = {};
        response.data.forEach(plantStatus => {
          statusMap[plantStatus.plant_id] = plantStatus.status;
        });

        // Update each plant's realtime_operation_status based on the response
        for (let index = 0; index < this.poolDataList.length; index++) {
          const plantId = this.poolDataList[index].plant_id;
          const status = statusMap[plantId];
          
          if (status === 'running') {
            this.poolDataList[index].realtime_operation_status = 1;
          } else if (status === 'stopped') {
            this.poolDataList[index].realtime_operation_status = 0;
          } else if (status === 'error') {
            this.poolDataList[index].realtime_operation_status = 2;
          } else {
            // Default to inactive for unknown statuses
            this.poolDataList[index].realtime_operation_status = 0;
          }
        }
      }
    } catch (error) {
      console.log('Error fetching realtime operation status:', error);
      // Set all plants to inactive on error
      for (let index = 0; index < this.poolDataList.length; index++) {
        this.poolDataList[index].realtime_operation_status = 0;
      }
    }
},
  selectMethod(method) {
    this.selectedResultIndex = -1;
    this.listPlantByIdDataResponse = [];
    this.selectedMethod = method;
    this.memberId = '';
    this.searchTermAutocomplete = '';
    // Clear table search when switching methods
    this.searchTerm = '';
    this.filteredPoolDataList = [...this.poolDataList];
  },


  async fetchPlantInfo(plantId) {
    try {
      const bodyData = {
        plant_id: Number(plantId),
      };
      
      const url = `${this.subDataUrl}/bridge/rx_data/plant/plant_info/get`;
      const response = await apiRequest('post', url, bodyData);
      
      if (response.errorCode === 0 && response.data) {
        return response.data;
      }
      
      return null;
    } catch (error) {
      throw new Error("Failed to fetch plant data. Please try again later.");
    }
  },

  async getPlantById() {
    this.selectedResultIndex = -1;
    
    if (Number(this.memberId) > 0) {
      try {
        const plantData = await this.fetchPlantInfo(this.memberId);
        this.listPlantByIdDataResponse = plantData || [];
      } catch (error) {
        this.showModal = true;
        this.infoTitle = "Error";
        this.infoMessage = error.message;
      }
    }
  },
  async activateRedxAppView(plantId, accountName) {
    try {     
      const bodyData = {
        plantId: plantId,
        accountName: accountName,
      };
      const url = `${this.subDataUrl}/proxy/rx/user/localvolt/info`;
      
      const response = await apiRequest('post', url, bodyData);
      // console.log('activateRedxAppView response: ', response);
    
      if (response.errorCode != 0) {
        console.log('activateRedxAppView error: ', response.errorMsg);
        // this.infoTitle = "Error";
        // this.infoMessage = response.errorMsg || 'Unexpected error occurred';
        // this.showModal = true;        
      }
    } catch (excpetion) {
      console.log('activateRedxAppView excpetion caught: ', excpetion);
    }
  },

  async addPlantToPool() {
    if (this.selectedResultIndex >= 0) {
      const selectedPlant = this.listPlantByIdDataResponse[this.selectedResultIndex];
      try {
        //// Activate the Renox app view for the selected plant
        this.activateRedxAppView(selectedPlant.plant_id, selectedPlant.account_name);
        const bodyData = {
          plant_id: selectedPlant.plant_id,
          alias: selectedPlant.account_name + ' - ' + selectedPlant.plant_name,
          retailer_id: 2,
          ai_control_status: 1,
        };

        const url = `${this.subDataUrl}/ai_pool_users/set`;
        const response = await apiRequest('post', url, bodyData);

        if (response.errorCode === 0) {
          this.infoTitle = "Success";
          this.infoMessage = "New AI pool member has been added successfully";
          this.showModal = true;
          this.selectedResultIndex = -1;
          this.listPlantByIdDataResponse = [];
          this.memberId = '';
          await this.getAllPoolData();

        } else {
          this.infoTitle = "Error";
          this.infoMessage = response.infoText || 'Unexpected error occurred';
          this.showModal = true;
        }
      } catch (error) {
        this.infoTitle = "Error";
        this.infoMessage = 'Unexpected backend response. Please try again later';
        this.showModal = true;
      }
    }
  },

  async getPlantByAutocomplete(inputValue) {
    this.selectedResultIndex = -1;
    if (inputValue.trim() === '' || inputValue.length < 3) {
      this.listPlantByIdDataResponse = [];
      return;
    }
    try {
      const bodyData = {
        input_text: inputValue,
      };
      const url = `${this.subDataUrl}/bridge/rx_data/autocomplete/plant_info/get`;
      const response = await apiRequest('post', url, bodyData);
      
      if (response.errorCode === 0 && response.data) {
        this.listPlantByIdDataResponse = response.data;
      }
    } catch (error) {
      this.showModal = true;
      this.infoTitle = "Error";
      this.infoMessage = "Failed to fetch plant data. Please try again later.";
    }
  },

  async removeFromPool(plantId) {
    try {
      const bodyData = {
        plant_id: plantId,
      };
 
      const url = `${this.subDataUrl}/ai_pool_users/delete`;
      const response = await apiRequest('post', url, bodyData);
      
      if (response.errorCode === 0) {
        this.infoTitle = "Success";
        this.infoMessage = "AI pool member has been removed successfully";
        this.showModal = true;
        this.selectedPlantId = null;
        await this.getAllPoolData();
      } else {
        this.infoTitle = "Error";
        this.infoMessage = response.infoText || 'Unexpected error occurred';
        this.showModal = true;
      }
    } catch (error) {
      this.infoTitle = "Error";
      this.infoMessage = 'Unexpected backend response. Please try again later';
      this.showModal = true;
    }
  },

  showConfirmationDialog(row) {
    this.isDialogVisible = true;
    this.selectedPlantId = row.plant_id;
  },

  handleConfirmed() {
    this.isDialogVisible = false;
    this.removeFromPool(this.selectedPlantId);
  },

  handleCancelled() {
    this.isDialogVisible = false;
    this.selectedPlantId = null;
  },
  toggleDetails(row) {
    // Check if this row is already open BEFORE clearing
    const wasOpen = this.showDetails[row.plant_id] === true;
    
    // Close all rows first
    this.showDetails = {};
    this.showAdvancedFields = false;
    
    // If it wasn't open, open it now; if it was open, leave it closed
    if (!wasOpen) {
      this.showDetails = { [row.plant_id]: true };
      const plant = this.poolDataList.find(p => p.plant_id === row.plant_id) || row;
      this.form = {
        alias: plant.alias || '',
        ai_control_status: plant.ai_control_status,
        retailer_api_key: plant.retailer_api_key || '',
        retailer_id: plant.retailer_id || 1,
        retailer_site_id: plant.retailer_site_id || '',
      };
    }
},
async saveChanges(row) {
    if (this.showDetails[row.plant_id]) {   
      try {
        const bodyData = {
          plant_id: row.plant_id,
          alias: this.form.alias,
          ai_control_status: Number(this.form.ai_control_status),
          // Add fields conditionally
          ...(this.form.retailer_api_key ? { retailer_api_key: this.form.retailer_api_key } : {}),
          ...(this.form.retailer_id ? { retailer_id: Number(this.form.retailer_id) } : {}),
          ...(this.form.retailer_site_id ? { retailer_site_id: this.form.retailer_site_id } : {}),
        };
        const url = `${this.subDataUrl}/ai_pool_users/update`;
        const response = await apiRequest('post', url, bodyData);
        if (response.errorCode === 0) {
          this.infoTitle = "Success";
          this.infoMessage = "AI pool member details updated successfully";
          this.showModal = true;
          this.showDetails = {};
          await this.getAllPoolData();
        } else {
          this.infoTitle = "Error";
          this.infoMessage = response.infoText || 'Unexpected error occurred';
          this.showModal = true;
        }
      } catch (error) {
        this.infoTitle = "Error";
        this.infoMessage = 'Unexpected backend response. Please try again later';
        this.showModal = true;
      }
    }
  },

  formatDate(dateString) {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    } catch (error) {
      return 'Invalid Date';
    }
  },

  getRetailerName(retailerId) {
    if (retailerId === 1) return 'Amber';
    if (retailerId === 2) return 'LocalVolts';
    return 'Unknown';
  },

  getRetailerCount(retailerId) {
    return this.filteredPoolDataList.filter(item => item.retailer_id === retailerId).length;
  },

  getOfflineCount() {
    return this.filteredPoolDataList.filter(item => item.abnormal_device_status === 1).length;
  },

  getRealtimeInactiveCount() {
    return this.filteredPoolDataList.filter(item => item.realtime_operation_status === 0).length;
  },

  getRealtimeErrorCount() {
    return this.filteredPoolDataList.filter(item => item.realtime_operation_status === 2).length;
  },

  filterTableData() {
    if (!this.searchTerm.trim()) {
      // If search term is empty, show all data
      this.filteredPoolDataList = [...this.poolDataList];
      return;
    }

    const searchLower = this.searchTerm.toLowerCase();
    
    this.filteredPoolDataList = this.poolDataList.filter(item => {
      // Search across multiple fields
      return (
        // Search by alias (plant name)
        (item.alias && item.alias.toLowerCase().includes(searchLower)) ||
        // Search by plant ID
        (item.plant_id && item.plant_id.toString().includes(searchLower)) ||
        // Search by retailer name
        (this.getRetailerName(item.retailer_id) && this.getRetailerName(item.retailer_id).toLowerCase().includes(searchLower)) ||
        // Search by date added
        (item.date_added && this.formatDate(item.date_added).toLowerCase().includes(searchLower)) ||
        // Search by AI control status text
        (this.getAIControlStatusText(item.ai_control_status) && this.getAIControlStatusText(item.ai_control_status).toLowerCase().includes(searchLower)) ||
        // Search by realtime operation status text
        (this.getRealtimeStatusText(item.realtime_operation_status) && this.getRealtimeStatusText(item.realtime_operation_status).toLowerCase().includes(searchLower)) ||
        // Search by device health status text
        (this.getDeviceHealthStatusText(item.abnormal_device_status, item.abnormal_device_count) && this.getDeviceHealthStatusText(item.abnormal_device_status, item.abnormal_device_count).toLowerCase().includes(searchLower))
      );
    });
  },

  clearSearch() {
    this.searchTerm = '';
    this.filteredPoolDataList = [...this.poolDataList]; // Reset to show all data
    
    // If user was scrolled down and clears search, restore scroll position
    if (this.scrollPosition > 0) {
      this.$nextTick(() => {
        this.restoreScrollPosition();
      });
    }
  },

  // Helper methods for search text
  getAIControlStatusText(status) {
    switch(status) {
      case 0: return 'Disabled';
      case 1: return 'Enabled [AUTO]';
      case 2: return 'Special Case [TIMED]';
      case 3: return 'v1.0';
      case 4: return 'v2.0';
      case 5: return 'v1.1';
      case 6: return 'v1.1.1';
      case 7: return 'v1.1.2';
      case 8: return 'v1.1.3';
      case 9: return 'v1.2';
      case 10: return 'v1.2.0-jcs';
      case 11: return 'v1.2.1';
      case 12: return 'v1.2.2';
      default: return 'Unknown';
    }
  },

  getRealtimeStatusText(status) {
    if (status === 1) return 'Active';
    if (status === 2) return 'Error';
    return 'Inactive';
  },

  getDeviceHealthStatusText(status, count) {
    if (status === 1) {
      return `${count} ${count === 1 ? 'Device' : 'Devices'} Offline`;
    }
    return 'All Online';
  },

  toggleAdvancedFields() {
    this.showAdvancedFields = !this.showAdvancedFields;
  },

  // Check if a date is within the last 7 days
  isRecentlyAdded(dateString) {
    if (!dateString) return false;
    try {
      const addedDate = new Date(dateString);
      const now = new Date();
      const diffTime = Math.abs(now - addedDate);
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      return diffDays < 7;
    } catch (error) {
      return false;
    }
  },

  // Get the badge text for recently added members
  getNewBadgeText(dateString) {
    if (!dateString) return '';
    try {
      const addedDate = new Date(dateString);
      const now = new Date();
      const diffTime = Math.abs(now - addedDate);
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      
      if (diffDays === 0) {
        return 'New! Joined today';
      } else if (diffDays === 1) {
        return 'Joined 1 day ago';
      } else {
        return `Joined ${diffDays} days ago`;
      }
    } catch (error) {
      return '';
    }
  },


},

  // Watch for route changes
  watch: {
    $route(to, from) {
      if (to.name === 'HomePage' && from.name !== 'HomePage') {
        // We're entering HomePage from another route
        this.isOnHomePage = true;
        this.$nextTick(() => {
          this.restoreScrollPosition();
        });
      } else if (to.name !== 'HomePage' && from.name === 'HomePage') {
        // We're leaving HomePage for another route
        this.isOnHomePage = false;
        this.saveScrollPosition();
      }
    }
  },

  created() {
    this.readFromCookies();
    this.getAllPoolData();
    this.startInterval();
    this.setupScrollListener(); // Setup scroll listener on component mount
    this.setupVisibilityListener(); // Setup visibility listener on component mount
    this.setupPopStateListener(); // Setup popstate listener on component mount
    // Listen for environment changes
    eventBus.on('environment-changed', this.handleEnvironmentChange);
    // Don't restore scroll position here - let the route watcher handle it
  },

  // Vue Router navigation guards
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // Component is created, but not yet mounted
      // We'll handle scroll restoration in the route watcher
    });
  },

  beforeRouteLeave(to, from, next) {
    // Save scroll position before leaving the route
    // This is now handled by the route watcher, but keep for safety
    this.isOnHomePage = false;
    this.saveScrollPosition();
    next();
  },

  mounted() {
    // Component is mounted, we're now on HomePage
    this.isOnHomePage = true;
    
    // If this is the initial load of HomePage, restore scroll position
    if (this.$route.name === 'HomePage') {
      this.$nextTick(() => {
        this.restoreScrollPosition();
      });
    }
  },

beforeUnmount() {
    // Clear the interval to avoid memory leaks
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.removeScrollListener(); // Remove scroll listener on component unmount
    this.removeVisibilityListener(); // Remove visibility listener on component unmount
    this.removePopStateListener(); // Remove popstate listener on component unmount
    // Remove the event listener when component is destroyed
    eventBus.off('environment-changed', this.handleEnvironmentChange);
    this.clearScrollPosition(); // Clear scroll position on component unmount
  },
};
</script>
<style scoped>
  .page-container {
    margin: 0;
    padding: 0;
    scroll-behavior: auto; /* Disable smooth scrolling to prevent conflicts with programmatic scrolling */
  }

  /* Ensure smooth scrolling for user interactions but not for programmatic scrolling */
  html {
    scroll-behavior: smooth;
  }

  /* Prevent scroll jumping when restoring position */
  body {
    scroll-behavior: auto;
  }

  .pool-stats-container {
    margin: 20px 0;
    padding: 0 20px;
  }

  .stats-card {
    background: var(--card-bg);
    border: 1px solid var(--border-color);
    border-radius: 12px;
    padding: 20px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    box-shadow: 0 2px 8px var(--shadow-color);
    flex-wrap: wrap;
    gap: 20px;
  }

  .stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    min-width: 120px;
  }

  .stat-label {
    font-size: 0.9rem;
    color: var(--text-tertiary);
    font-weight: 500;
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .stat-value {
    font-size: 2rem;
    font-weight: bold;
    color: var(--custom-color1);
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  .stat-value.warning {
    color: #ff6b35;
  }
  
  .tabs {
    padding-top: 20px;
    display: flex;
    margin-bottom: 20px;
  }
  
  .tabs button {
    padding: 10px;
    margin: 10px 0px 10px 30px;
    cursor: pointer;
    border: none;
    margin-right: 5px;
    border-radius: 5px; /* Rounded borders */
    transition: color 0.3s;
    position: relative; /* For positioning the border */
  }

  
  
  .tabs button.active::after {
    content: ''; /* Empty content for the border */
    position: absolute;
    left: 0;
    right: 0;
    bottom: -5px; /* Positioning the line */
    height: 3px; /* Thickness of the line */
    background-color: var(--custom-color1); /* Green line color */
  }
  
  .tabs button.inactive {
    color: var(--text-tertiary); /* Active tab text color */
    opacity: 0.6; /* Gray out inactive tabs */
  }
  
  .tab-content {
    margin: 20px;
    padding: 20px;
    border: 1px solid var(--border-color);
    border-radius: 5px; /* Match border radius with tabs */
    background: var(--bg-primary);
  }

  .options {
    display: flex;
    gap: 10px; /* Space between the option buttons */
  }


.member-addition {
  margin-top: 20px;
}

input {
  padding: 8px;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 200px; /* Fixed width for input */
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  cursor: pointer;
  padding: 5px;
  border: 1px solid var(--border-color);
  margin-top: 5px;
  color: var(--text-primary);
}

li:hover {
  background-color: var(--bg-secondary); /* Highlight on hover */
}

.custom-button {
  cursor: pointer;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
  border-radius: 5px;
  font-size: 14px;
  text-align: center;
}

.custom-button:hover {
  box-shadow: 0 2px 6px rgba(60,64,67,0.25);
  background: var(--custom-color1);
  color: white;
}

.button-option {
   cursor: pointer;
   background: var(--bg-secondary);
   color: var(--text-secondary);
   border: 1px solid var(--border-color);
   border-radius: 8px;
   font-size: 0.8rem;
   padding: 10px 16px;
   transition: all 0.3s ease;
   margin: 10px;
}

.button-option:hover {
   box-shadow: 0 2px 6px rgba(60,64,67,0.25);
}

.button-option.active {
   border: 2px solid #20cc20;
   border-radius: 8px;
   background: #20cc20;
   box-shadow: 0 0 0 2px rgba(32, 204, 32, 0.3);
   color: white;
   font-weight: 600;
   transform: scale(1.03);
}

.selectedResult {
  background-color: var(--custom-color1); /* Highlight selected result */
}

a{
  text-decoration: none; /* Remove underline */
}
.result-item{
    border-radius: 5px; /* Rounded borders */
    text-decoration: none;
    color: var(--text-primary);
  }

  .table-container {
    width: 100%;
    overflow-x: auto;
    background: var(--card-bg);
    border-radius: 12px;
    box-shadow: 0 4px 16px var(--shadow-color);
    padding: 1rem;
    margin-top: 1rem;
  }

  .full-width-table {
    border-collapse: separate;
    border-spacing: 0;
    width: 100%;
    background: var(--card-bg);
  }
    
  th, td {
    padding: 14px 12px;
    text-align: center;
    font-size: 0.875rem;
    border-bottom: 1px solid var(--border-color-light);
    transition: all 0.2s ease;
    color: var(--text-primary);
  }
  
  th {
    background: var(--bg-secondary);
    color: var(--text-secondary);
    font-weight: 600;
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    position: sticky;
    top: 0;
    z-index: 10;
    border-bottom: 2px solid var(--border-color);
    box-shadow: 0 2px 4px var(--shadow-color);
  }

  tbody tr {
    transition: all 0.2s ease;
  }

  tbody tr:hover {
    background-color: var(--bg-secondary);
    transform: scale(1.001);
    box-shadow: 0 2px 8px var(--shadow-color);
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  font-awesome-icon {
    font-size: 5rem;
  }

  .icon-disabled {
    color: red;
  }

  .icon-enabled {
    color: var(--custom-color1);
  }

  .details-row {
    padding: 10px;
    border: 1px solid var(--custom-color1);
    border-radius: 5px;
    margin-top: 10px;
  }

  .arrow-button {
    background-color: var(--custom-color1);
    color: white;
    font-size: 1.2vm;
    margin-left: 5px;
    margin-right: 5px;
  }

  .sensitive-button {
    background-color: var(--bg-secondary);
    color: red;
    font-weight: bold;
  }

  .sensitive-button:hover {
    background-color: var(--custom-color1);
    color: red;
    font-weight: bold;
  }

  .neutral-button {
    background-color: var(--bg-secondary);
    color: var(--text-primary);
  }

input,
select {
  width: 60%;
  padding: 10px;
  margin: 10px 0;
  border-radius: 8px;
  border-width: 0.1px;
} 

  .status-circle {
    width: 0.9rem;
    height: 0.9rem;
    border-radius: 50%;
    display: inline-block;
  }

  .status-loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .status-loading-spinner {
    width: 1rem;
    height: 1rem;
    border: 2px solid var(--bg-tertiary);
    border-top: 2px solid var(--custom-color1);
    border-radius: 50%;
    animation: status-spin 0.8s linear infinite;
    display: inline-block;
  }

  @keyframes status-spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .status-disabled {
    background-color: red;
  }

  .status-enabled {
    background-color: var(--custom-color1);
  }

  .status-warning {
    background-color: #ffa500; /* Light orange color for warning */
  }

  .status-error {
    background-color: #dc3545; /* Red color for error */
  }

  .abnormal-device-row {
    background-color: #fff3e0; /* Light orange background for rows with abnormal devices */
    color: #333; /* Dark text for light mode */
  }

  .abnormal-device-row:hover {
    background-color: #ffe0b2; /* Slightly darker orange on hover */
  }

  .dark-mode .abnormal-device-row {
    background-color: #ffcc80; /* Darker orange background for dark mode */
    color: #000000; /* Black text for readability on orange */
  }

  .dark-mode .abnormal-device-row:hover {
    background-color: #ffe0b2; /* Slightly darker orange on hover */
  }

  .dark-mode .abnormal-device-row * {
    color: #000000 !important; /* Force all text inside to be black in dark mode */
  }

  .dark-mode .abnormal-device-row p,
  .dark-mode .abnormal-device-row span,
  .dark-mode .abnormal-device-row td {
    color: #000000 !important; /* Ensure all text elements are black */
  }

  /* Keep action buttons with their original colors in dark mode for offline rows */
  .dark-mode .abnormal-device-row .action-buttons-column {
    color: inherit !important;
  }

  .dark-mode .abnormal-device-row .action-buttons-column button {
    color: inherit !important;
  }

  .dark-mode .abnormal-device-row .action-buttons-column .arrow-button {
    background-color: var(--custom-color1) !important;
    color: white !important;
  }

  .dark-mode .abnormal-device-row .action-buttons-column .sensitive-button {
    background-color: var(--bg-secondary) !important;
    color: red !important;
  }

  .dark-mode .abnormal-device-row .action-buttons-column .sensitive-button:hover {
    background-color: var(--custom-color1) !important;
    color: red !important;
  }

  .dark-mode .abnormal-device-row .action-buttons-column .neutral-button {
    background-color: var(--bg-secondary) !important;
    color: var(--text-primary) !important;
  }

  @keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
  }

  .blink {
    animation: blink 0.8s infinite;
  }

   .clickable-cell {
    cursor: pointer;
    /* text-decoration: underline; */
   }

  .tools-container {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
    }

  .custom-input {
    margin-right: 10px;
  }

  .search-container {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    padding: 15px;
    background: var(--bg-secondary);
    border-radius: 12px;
    border: 1px solid var(--border-color);
    box-shadow: 0 2px 8px var(--shadow-color);
  }

  .search-input {
    flex-grow: 1;
    padding: 12px 16px;
    border: 1px solid var(--input-border);
    border-radius: 8px;
    font-size: 1rem;
    outline: none;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    background-color: var(--input-bg);
    color: var(--text-primary);
  }

  .search-input:focus {
    border-color: var(--custom-color1);
    box-shadow: 0 0 0 3px rgba(32, 204, 32, 0.1);
  }

  .search-input::placeholder {
    color: var(--text-tertiary);
    font-style: italic;
  }

  .clear-search-btn {
    background-color: #dc3545;
    color: white;
    border: none;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 1.2rem;
    transition: all 0.3s ease;
    margin-left: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  .clear-search-btn:hover {
    background-color: #c82333;
    transform: scale(1.05);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  }

  .sensitive-fields-container {
    border: 3px solid #dc3545;
    border-radius: 8px;
    padding: 15px;
    margin: 10px 0;
    background-color: var(--bg-secondary);
    position: relative;
  }

  .sensitive-warning {
    background-color: #dc3545;
    color: white;
    padding: 8px 12px;
    border-radius: 5px;
    margin-bottom: 15px;
    text-align: center;
    font-size: 0.9rem;
    box-shadow: 0 2px 4px rgba(220, 53, 69, 0.3);
  }

  .alias-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
  }

  .new-badge {
    display: inline-block;
    background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
    color: white;
    padding: 3px 8px;
    border-radius: 10px;
    font-size: 0.6rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    box-shadow: 0 2px 6px rgba(76, 175, 80, 0.4);
    animation: pulse 2s ease-in-out infinite;
    white-space: nowrap;
    position: relative;
  }

  .new-badge::before,
  .new-badge::after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    height: 2px;
    width: 20px;
    background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
    box-shadow: 0 1px 3px rgba(76, 175, 80, 0.3);
  }

  .new-badge::before {
    right: 100%;
    margin-right: 4px;
  }

  .new-badge::after {
    left: 100%;
    margin-left: 4px;
  }

  @keyframes pulse {
    0%, 100% {
      box-shadow: 0 2px 6px rgba(76, 175, 80, 0.4);
    }
    50% {
      box-shadow: 0 2px 10px rgba(76, 175, 80, 0.6);
    }
  }


  .flex-container > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 750px) {
    .table-container {
      padding: 0.5rem;
      border-radius: 8px;
    }

    th, td {
      font-size: 0.7rem;
      padding: 10px 6px;
    }

    th {
      font-size: 0.75rem;
    }

    button {
      font-size: 10px;
    }

    .arrow-button {
      font-size: 0.3rem;
      padding: 0.1rem;
    }

    .status-circle {
      width: 8px;
      height: 8px;
    }

    .status-loading-spinner {
      width: 8px;
      height: 8px;
      border-width: 1.5px;
    }

    .status-loading-container p {
      font-size: 0.6rem;
    }

    .abnormal-device-row {
      background-color:rgb(224, 201, 165);
      color: #333;
    }

    .dark-mode .abnormal-device-row {
      background-color: #fff3e0;
      color: #000000;
    }

    .dark-mode .abnormal-device-row * {
      color: #000000 !important; /* Force all text inside to be black in dark mode */
    }

    .dark-mode .abnormal-device-row p,
    .dark-mode .abnormal-device-row span,
    .dark-mode .abnormal-device-row td {
      color: #000000 !important; /* Ensure all text elements are black */
    }

    /* Keep action buttons with their original colors in dark mode for offline rows */
    .dark-mode .abnormal-device-row .action-buttons-column {
      color: inherit !important;
    }

    .dark-mode .abnormal-device-row .action-buttons-column button {
      color: inherit !important;
    }

    .dark-mode .abnormal-device-row .action-buttons-column .arrow-button {
      background-color: var(--custom-color1) !important;
      color: white !important;
    }

    .dark-mode .abnormal-device-row .action-buttons-column .sensitive-button {
      background-color: var(--bg-secondary) !important;
      color: red !important;
    }

    .dark-mode .abnormal-device-row .action-buttons-column .sensitive-button:hover {
      background-color: var(--custom-color1) !important;
      color: red !important;
    }

    .dark-mode .abnormal-device-row .action-buttons-column .neutral-button {
      background-color: var(--bg-secondary) !important;
      color: var(--text-primary) !important;
    }

    .stats-card {
      flex-direction: column;
      gap: 15px;
      padding: 15px;
    }

    .stat-item {
      min-width: 100px;
    }

    .stat-label {
      font-size: 0.4rem;
    }

    .stat-value {
      font-size: 1rem;
    }

    .tools-container {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .search-container {
      padding: 5px;
      flex-direction: column;
      gap: 10px;
    }

    .search-input {
      width: 100%;
      font-size: 0.4rem;
      padding: 10px 12px;
    }

    .clear-search-btn {
      align-self: flex-end;
      margin-left: 0;
      width: 32px;
      height: 32px;
      font-size: 1rem;
    }

    .new-badge {
      font-size: 0.5rem;
      padding: 2px 5px;
      border-radius: 6px;
    }

    .new-badge::before,
    .new-badge::after {
      width: 12px;
      height: 1.5px;
      margin-left: 3px;
      margin-right: 3px;
    }

    .alias-cell {
      gap: 4px;
    }
  }
</style>